// @ts-ignore
import { isWebpSupported } from 'react-image-webp/dist/utils'

import collectionImgJpg_1 from 'assets/images/collections_1.jpg'
import collectionImgJpg_2 from 'assets/images/collections_2.jpg'
import collectionImgJpg_3 from 'assets/images/collections_3.jpg'
import collectionImgJpg_4 from 'assets/images/collections_4.jpg'
import collectionImgJpg_5 from 'assets/images/collections_5.jpg'
import collectionImgJpg_6 from 'assets/images/collections_6.jpg'
import collectionImgJpg_7 from 'assets/images/collections_7.jpg'
import collectionImgJpg_8 from 'assets/images/collections_8.jpg'
import collectionImgJpg_9 from 'assets/images/collections_9.jpg'

import collectionImgWebp_1 from 'assets/images/collections_1.webp'
import collectionImgWebp_2 from 'assets/images/collections_2.webp'
import collectionImgWebp_3 from 'assets/images/collections_3.webp'
import collectionImgWebp_4 from 'assets/images/collections_4.webp'
import collectionImgWebp_5 from 'assets/images/collections_5.webp'
import collectionImgWebp_6 from 'assets/images/collections_6.webp'
import collectionImgWebp_7 from 'assets/images/collections_7.webp'
import collectionImgWebp_8 from 'assets/images/collections_8.webp'
import collectionImgWebp_9 from 'assets/images/collections_9.webp'

let collectionImages = {
  classic: collectionImgWebp_1,
  laconic: collectionImgWebp_2,
  party: collectionImgWebp_3,
  romantic: collectionImgWebp_4,
  luxurious: collectionImgWebp_5,
  kids: collectionImgWebp_6,
  bright: collectionImgWebp_7,
  birthday: collectionImgWebp_8,
  wedding: collectionImgWebp_9,
}

if (!isWebpSupported()) {
  collectionImages = {
    classic: collectionImgJpg_1,
    laconic: collectionImgJpg_2,
    party: collectionImgJpg_3,
    romantic: collectionImgJpg_4,
    luxurious: collectionImgJpg_5,
    kids: collectionImgJpg_6,
    bright: collectionImgJpg_7,
    birthday: collectionImgJpg_8,
    wedding: collectionImgJpg_9,
  }
}

const COLLECTION_LIST = [
  {
    id: '1',
    title: 'Торты',
    description: 'На День Рождения',
    src: collectionImages.birthday,
    isWide: false,
    isShow: true,
    direct: 'column',
    images: [
      { src: '/collections/birthday/birthday_125.jpg', title: '' },
      { src: '/collections/birthday/birthday_126.jpg', title: '' },
      { src: '/collections/birthday/birthday_127.jpg', title: '' },
      { src: '/collections/birthday/birthday_128.jpg', title: '' },
      { src: '/collections/birthday/birthday_129.jpg', title: '' },
      { src: '/collections/birthday/birthday_130.jpg', title: '' },
      { src: '/collections/birthday/birthday_131.jpg', title: '' },
      { src: '/collections/birthday/birthday_132.jpg', title: '' },
      { src: '/collections/birthday/birthday_133.jpg', title: '' },
      {
        src: '/collections/birthday/birthday_134.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_135.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_136.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_137.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_138.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_139.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_140.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_141.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_142.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      { src: '/collections/birthday/birthday_115.jpg', title: '' },
      { src: '/collections/birthday/birthday_116.jpg', title: '' },
      { src: '/collections/birthday/birthday_117.jpg', title: '' },
      { src: '/collections/birthday/birthday_118.jpg', title: '' },
      { src: '/collections/birthday/birthday_119.jpg', title: '' },
      {
        src: '/collections/birthday/birthday_120.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_121.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_122.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_123.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_124.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      { src: '/collections/birthday/birthday_110.jpg', title: '' },
      { src: '/collections/birthday/birthday_111.jpg', title: '' },
      { src: '/collections/birthday/birthday_112.jpg', title: '' },
      {
        src: '/collections/birthday/birthday_113.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_114.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      { src: '/collections/birthday/birthday_106.jpg', title: '' },
      { src: '/collections/birthday/birthday_107.jpg', title: '' },
      {
        src: '/collections/birthday/birthday_108.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_109.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      { src: '/collections/birthday/birthday_98.jpg', title: '' },
      { src: '/collections/birthday/birthday_99.jpg', title: '' },
      { src: '/collections/birthday/birthday_100.jpg', title: '' },
      { src: '/collections/birthday/birthday_101.jpg', title: '' },
      {
        src: '/collections/birthday/birthday_102.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_103.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_104.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_105.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      { src: '/collections/birthday/birthday_88.jpg', title: '' },
      { src: '/collections/birthday/birthday_89.jpg', title: '' },
      { src: '/collections/birthday/birthday_90.jpg', title: '' },
      { src: '/collections/birthday/birthday_91.jpg', title: '' },
      { src: '/collections/birthday/birthday_92.jpg', title: '' },
      {
        src: '/collections/birthday/birthday_93.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_94.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_95.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_96.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_97.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      { src: '/collections/birthday/birthday_80.jpg', title: '' },
      { src: '/collections/birthday/birthday_81.jpg', title: '' },
      { src: '/collections/birthday/birthday_82.jpg', title: '' },
      { src: '/collections/birthday/birthday_83.jpg', title: '' },
      {
        src: '/collections/birthday/birthday_84.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_85.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_86.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_87.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      { src: '/collections/birthday/birthday_71.jpg', title: '' },
      { src: '/collections/birthday/birthday_72.jpg', title: '' },
      { src: '/collections/birthday/birthday_73.jpg', title: '' },
      { src: '/collections/birthday/birthday_74.jpg', title: '' },
      {
        src: '/collections/birthday/birthday_75.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_76.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_77.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_78.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_79.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      { src: '/collections/birthday/birthday_68.jpg', title: '' },
      { src: '/collections/birthday/birthday_69.jpg', title: '' },
      {
        src: '/collections/birthday/birthday_70.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      { src: '/collections/birthday/birthday_47.jpg', title: '' },
      { src: '/collections/birthday/birthday_48.jpg', title: '' },
      { src: '/collections/birthday/birthday_49.jpg', title: '' },
      { src: '/collections/birthday/birthday_51.jpg', title: '' },
      { src: '/collections/birthday/birthday_52.jpg', title: '' },
      { src: '/collections/birthday/birthday_53.jpg', title: '' },
      { src: '/collections/birthday/birthday_54.jpg', title: '' },
      { src: '/collections/birthday/birthday_55.jpg', title: '' },
      { src: '/collections/birthday/birthday_56.jpg', title: '' },
      {
        src: '/collections/birthday/birthday_57.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_58.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_59.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_60.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_61.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_63.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_64.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_65.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_66.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_67.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      { src: '/collections/birthday/birthday_41.jpg', title: '' },
      { src: '/collections/birthday/birthday_42.jpg', title: '' },
      { src: '/collections/birthday/birthday_43.jpg', title: '' },
      { src: '/collections/birthday/birthday_44.jpg', title: '' },
      { src: '/collections/birthday/birthday_45.jpg', title: '' },
      { src: '/collections/birthday/birthday_46.jpg', title: '' },
      { src: '/collections/birthday/birthday_40.jpg', title: '' },
      { src: '/collections/birthday/birthday_1.jpg', title: '' },
      { src: '/collections/birthday/birthday_2.jpg', title: '' },
      { src: '/collections/birthday/birthday_3.jpg', title: '' },
      { src: '/collections/birthday/birthday_4.jpg', title: '' },
      { src: '/collections/birthday/birthday_5.jpg', title: '' },
      { src: '/collections/birthday/birthday_6.jpg', title: '' },
      { src: '/collections/birthday/birthday_7.jpg', title: '' },
      { src: '/collections/birthday/birthday_8.jpg', title: '' },
      { src: '/collections/birthday/birthday_9.jpg', title: '' },
      { src: '/collections/birthday/birthday_10.jpg', title: '' },
      { src: '/collections/birthday/birthday_11.jpg', title: '' },
      { src: '/collections/birthday/birthday_12.jpg', title: '' },
      { src: '/collections/birthday/birthday_13.jpg', title: '' },
      { src: '/collections/birthday/birthday_14.jpg', title: '' },
      { src: '/collections/birthday/birthday_15.jpg', title: '' },
      { src: '/collections/birthday/birthday_16.jpg', title: '' },
      {
        src: '/collections/birthday/birthday_134.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_135.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_136.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_137.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_138.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_139.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_140.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_141.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_142.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_120.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_121.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_122.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_123.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_124.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_113.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_114.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_70.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_108.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_109.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_102.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_103.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_104.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_105.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_93.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_94.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_95.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_96.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_97.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_84.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_85.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_86.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_87.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_75.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_76.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_77.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_78.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_79.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      { src: '/collections/birthday/birthday_17.jpg', title: '' },
      { src: '/collections/birthday/birthday_18.jpg', title: '' },
      {
        src: '/collections/birthday/birthday_57.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_58.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_59.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_60.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_61.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_63.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_64.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_65.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_66.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/birthday/birthday_67.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      { src: '/collections/birthday/birthday_19.jpg', title: '' },
      { src: '/collections/birthday/birthday_20.jpg', title: '' },
      { src: '/collections/birthday/birthday_21.jpg', title: '' },
      { src: '/collections/birthday/birthday_22.jpg', title: '' },
      { src: '/collections/birthday/birthday_23.jpg', title: '' },
      { src: '/collections/birthday/birthday_24.jpg', title: '' },
      { src: '/collections/birthday/birthday_25.jpg', title: '' },
      { src: '/collections/birthday/birthday_26.jpg', title: '' },
      { src: '/collections/birthday/birthday_27.jpg', title: '' },
      { src: '/collections/birthday/birthday_28.jpg', title: '' },
      { src: '/collections/birthday/birthday_29.jpg', title: '' },
      { src: '/collections/birthday/birthday_30.jpg', title: '' },
      { src: '/collections/birthday/birthday_31.jpg', title: '' },
      { src: '/collections/birthday/birthday_32.jpg', title: '' },
      { src: '/collections/birthday/birthday_33.jpg', title: '' },
      { src: '/collections/birthday/birthday_34.jpg', title: '' },
      { src: '/collections/birthday/birthday_35.jpg', title: '' },
      { src: '/collections/birthday/birthday_36.jpg', title: '' },
      { src: '/collections/birthday/birthday_37.jpg', title: '' },
      { src: '/collections/birthday/birthday_38.jpg', title: '' },
      { src: '/collections/birthday/birthday_39.jpg', title: '' },
    ],
  },
  {
    id: '2',
    title: 'Торты',
    description: 'Праздники',
    src: collectionImages.party,
    isWide: false,
    isShow: true,
    direct: 'column',
    images: [
      { src: '/collections/party/party_50.jpg', title: '' },
      { src: '/collections/party/party_51.jpg', title: '' },
      { src: '/collections/party/party_52.jpg', title: '' },
      { src: '/collections/party/party_53.jpg', title: '' },
      { src: '/collections/party/party_54.jpg', title: '' },
      {
        src: '/collections/party/party_55.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/party/party_56.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/party/party_57.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/party/party_58.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      { src: '/collections/party/party_42.jpg', title: '' },
      { src: '/collections/party/party_43.jpg', title: '' },
      { src: '/collections/party/party_44.jpg', title: '' },
      { src: '/collections/party/party_45.jpg', title: '' },
      {
        src: '/collections/party/party_46.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/party/party_47.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/party/party_48.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/party/party_49.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      { src: '/collections/party/party_41.jpg', title: '' },
      { src: '/collections/party/party_38.jpg', title: '' },
      { src: '/collections/party/party_39.jpg', title: '' },
      {
        src: '/collections/party/party_40.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      { src: '/collections/party/party_31.jpg', title: '' },
      { src: '/collections/party/party_32.jpg', title: '' },
      { src: '/collections/party/party_33.jpg', title: '' },
      { src: '/collections/party/party_34.jpg', title: '' },
      {
        src: '/collections/party/party_35.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/party/party_36.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/party/party_37.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      { src: '/collections/party/party_28.jpg', title: '' },
      { src: '/collections/party/party_29.jpg', title: '' },
      {
        src: '/collections/party/party_30.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      { src: '/collections/party/party_26.jpg', title: '' },
      { src: '/collections/party/party_27.jpg', title: '' },
      { src: '/collections/party/party_24.jpg', title: '' },
      { src: '/collections/party/party_25.jpg', title: '' },
      { src: '/collections/party/party_19.jpg', title: '' },
      { src: '/collections/party/party_20.jpg', title: '' },
      { src: '/collections/party/party_21.jpg', title: '' },
      {
        src: '/collections/party/party_22.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/party/party_23.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      { src: '/collections/party/party_15.jpg', title: '' },
      { src: '/collections/party/party_16.jpg', title: '' },
      { src: '/collections/party/party_17.jpg', title: '' },
      { src: '/collections/party/party_18.jpg', title: '' },
      {
        src: '/collections/party/party_55.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/party/party_56.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/party/party_57.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/party/party_58.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      { src: '/collections/party/party_1.jpg', title: '' },
      {
        src: '/collections/party/party_46.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/party/party_47.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/party/party_48.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/party/party_49.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/party/party_40.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      { src: '/collections/party/party_2.jpg', title: '' },
      {
        src: '/collections/party/party_35.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/party/party_36.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/party/party_37.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/party/party_30.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      { src: '/collections/party/party_3.jpg', title: '' },
      { src: '/collections/party/party_4.jpg', title: '' },
      { src: '/collections/party/party_5.jpg', title: '' },
      { src: '/collections/party/party_6.jpg', title: '' },
      {
        src: '/collections/party/party_22.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/party/party_23.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      { src: '/collections/party/party_7.jpg', title: '' },
      { src: '/collections/party/party_8.jpg', title: '' },
      { src: '/collections/party/party_9.jpg', title: '' },
      { src: '/collections/party/party_10.jpg', title: '' },
      { src: '/collections/party/party_11.jpg', title: '' },
      { src: '/collections/party/party_12.jpg', title: '' },
      { src: '/collections/party/party_13.jpg', title: '' },
      { src: '/collections/party/party_14.jpg', title: '' },
    ],
  },
  {
    id: '3',
    title: 'Торты',
    description: 'Для детей',
    src: collectionImages.kids,
    isWide: false,
    isShow: true,
    direct: 'column',
    images: [
      { src: '/collections/for_kids/for_kids_139.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_140.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_141.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_142.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_143.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_144.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_145.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_146.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_147.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_148.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_149.jpg', title: '' },
      {
        src: '/collections/for_kids/for_kids_150.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_151.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_152.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_153.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_154.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_155.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_156.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_157.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_158.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_159.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      { src: '/collections/for_kids/for_kids_126.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_127.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_128.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_129.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_130.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_131.jpg', title: '' },
      {
        src: '/collections/for_kids/for_kids_132.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_133.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_134.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_135.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_136.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_137.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_138.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_121.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_122.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_123.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_124.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_125.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      { src: '/collections/for_kids/for_kids_109.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_110.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_111.jpg', title: '' },
      {
        src: '/collections/for_kids/for_kids_112.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_113.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_114.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_115.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      { src: '/collections/for_kids/for_kids_97.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_98.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_99.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_100.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_101.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_102.jpg', title: '' },
      {
        src: '/collections/for_kids/for_kids_103.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_104.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_105.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_106.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_107.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_108.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      { src: '/collections/for_kids/for_kids_86.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_87.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_88.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_89.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_90.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_91.jpg', title: '' },
      {
        src: '/collections/for_kids/for_kids_92.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_93.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_94.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_95.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_96.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      { src: '/collections/for_kids/for_kids_80.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_81.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_82.jpg', title: '' },
      {
        src: '/collections/for_kids/for_kids_83.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_84.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_85.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      { src: '/collections/for_kids/for_kids_65.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_66.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_67.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_68.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_69.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_70.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_71.jpg', title: '' },
      {
        src: '/collections/for_kids/for_kids_72.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_73.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_74.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_75.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_76.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_77.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_78.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_63.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_64.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      { src: '/collections/for_kids/for_kids_61.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_62.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_41.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_42.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_43.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_44.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_45.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_46.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_47.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_48.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_49.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_50.jpg', title: '' },
      {
        src: '/collections/for_kids/for_kids_51.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_52.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_53.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_54.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_55.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_56.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_57.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_59.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_60.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      { src: '/collections/for_kids/for_kids_35.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_36.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_37.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_38.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_39.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_40.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_33.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_34.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_1.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_2.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_3.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_4.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_5.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_6.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_7.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_8.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_9.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_10.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_11.jpg', title: '' },

      {
        src: '/collections/for_kids/for_kids_121.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_122.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_123.jpg',
        title: '',
        isDesktopViewOnly: true,
      },

      {
        src: '/collections/for_kids/for_kids_150.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_151.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_152.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_153.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_154.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_155.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_156.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_157.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_158.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_159.jpg',
        title: '',
        isDesktopViewOnly: true,
      },

      {
        src: '/collections/for_kids/for_kids_132.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_133.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_134.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_135.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_136.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_137.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_138.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_124.jpg',
        title: '',
        isDesktopViewOnly: true,
      },

      {
        src: '/collections/for_kids/for_kids_125.jpg',
        title: '',
        isDesktopViewOnly: true,
      },

      {
        src: '/collections/for_kids/for_kids_112.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_113.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_114.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_115.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_103.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_104.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_105.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_106.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_107.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_108.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_92.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_93.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_94.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_95.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_96.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_83.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_84.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_85.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_72.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_73.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_74.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_75.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_76.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_77.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_78.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_64.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      { src: '/collections/for_kids/for_kids_12.jpg', title: '' },
      {
        src: '/collections/for_kids/for_kids_51.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_52.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_53.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_54.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_55.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_56.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_57.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_59.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/for_kids/for_kids_60.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      { src: '/collections/for_kids/for_kids_13.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_14.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_15.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_16.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_17.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_18.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_19.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_20.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_21.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_22.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_23.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_24.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_25.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_26.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_27.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_28.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_29.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_30.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_31.jpg', title: '' },
      { src: '/collections/for_kids/for_kids_32.jpg', title: '' },
    ],
  },
  {
    id: '4',
    title: 'Торты',
    description: 'Свадебные',
    src: collectionImages.wedding,
    isWide: false,
    isShow: true,
    direct: 'column',
    images: [
      { src: '/collections/wedding/wedding_41.jpg', title: '' },
      { src: '/collections/wedding/wedding_42.jpg', title: '' },
      { src: '/collections/wedding/wedding_43.jpg', title: '' },
      { src: '/collections/wedding/wedding_44.jpg', title: '' },
      { src: '/collections/wedding/wedding_45.jpg', title: '' },
      {
        src: '/collections/wedding/wedding_46.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/wedding/wedding_47.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/wedding/wedding_48.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/wedding/wedding_49.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      { src: '/collections/wedding/wedding_40.jpg', title: '' },
      { src: '/collections/wedding/wedding_37.jpg', title: '' },
      { src: '/collections/wedding/wedding_38.jpg', title: '' },
      {
        src: '/collections/wedding/wedding_39.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      { src: '/collections/wedding/wedding_35.jpg', title: '' },
      {
        src: '/collections/wedding/wedding_36.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      { src: '/collections/wedding/wedding_33.jpg', title: '' },
      {
        src: '/collections/wedding/wedding_34.jpg',
        title: '',
      },
      { src: '/collections/wedding/wedding_31.jpg', title: '' },
      { src: '/collections/wedding/wedding_32.jpg', title: '' },
      { src: '/collections/wedding/wedding_28.jpg', title: '' },
      { src: '/collections/wedding/wedding_29.jpg', title: '' },
      {
        src: '/collections/wedding/wedding_30.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      { src: '/collections/wedding/wedding_24.jpg', title: '' },
      { src: '/collections/wedding/wedding_25.jpg', title: '' },
      {
        src: '/collections/wedding/wedding_26.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      {
        src: '/collections/wedding/wedding_27.jpg',
        title: '',
        isMobileViewOnly: true,
      },
      { src: '/collections/wedding/wedding_20.jpg', title: '' },
      { src: '/collections/wedding/wedding_21.jpg', title: '' },
      { src: '/collections/wedding/wedding_1.jpg', title: '' },
      { src: '/collections/wedding/wedding_2.jpg', title: '' },
      { src: '/collections/wedding/wedding_3.jpg', title: '' },
      { src: '/collections/wedding/wedding_4.jpg', title: '' },
      { src: '/collections/wedding/wedding_5.jpg', title: '' },
      {
        src: '/collections/wedding/wedding_46.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/wedding/wedding_47.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/wedding/wedding_48.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/wedding/wedding_49.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      { src: '/collections/wedding/wedding_6.jpg', title: '' },
      {
        src: '/collections/wedding/wedding_39.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      { src: '/collections/wedding/wedding_7.jpg', title: '' },
      {
        src: '/collections/wedding/wedding_36.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      { src: '/collections/wedding/wedding_8.jpg', title: '' },
      { src: '/collections/wedding/wedding_9.jpg', title: '' },
      {
        src: '/collections/wedding/wedding_30.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/wedding/wedding_26.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/wedding/wedding_27.jpg',
        title: '',
        isDesktopViewOnly: true,
      },
      {
        src: '/collections/wedding/wedding_23.jpg',
        title: '',
      },
      { src: '/collections/wedding/wedding_10.jpg', title: '' },
      { src: '/collections/wedding/wedding_11.jpg', title: '' },
      { src: '/collections/wedding/wedding_12.jpg', title: '' },
      { src: '/collections/wedding/wedding_13.jpg', title: '' },
      { src: '/collections/wedding/wedding_14.jpg', title: '' },
      { src: '/collections/wedding/wedding_15.jpg', title: '' },
      { src: '/collections/wedding/wedding_16.jpg', title: '' },
      { src: '/collections/wedding/wedding_17.jpg', title: '' },
      { src: '/collections/wedding/wedding_18.jpg', title: '' },
      { src: '/collections/wedding/wedding_19.jpg', title: '' },
    ],
  },
  {
    id: '5',
    title: 'Торты',
    description: 'Лаконичные',
    src: collectionImages.laconic,
    isWide: false,
    isShow: false,
    direct: 'column',
    images: [
      { src: '/collections/laconic/laconic_1.jpg', title: '' },
      { src: '/collections/laconic/laconic_2.jpg', title: '' },
      { src: '/collections/laconic/laconic_3.jpg', title: '' },
      { src: '/collections/laconic/laconic_4.jpg', title: '' },
      { src: '/collections/laconic/laconic_5.jpg', title: '' },
      { src: '/collections/laconic/laconic_6.jpg', title: '' },
      { src: '/collections/laconic/laconic_7.jpg', title: '' },
      { src: '/collections/laconic/laconic_8.jpg', title: '' },
      { src: '/collections/laconic/laconic_9.jpg', title: '' },
      { src: '/collections/laconic/laconic_10.jpg', title: '' },
      { src: '/collections/laconic/laconic_11.jpg', title: '' },
      { src: '/collections/laconic/laconic_12.jpg', title: '' },
      { src: '/collections/laconic/laconic_13.jpg', title: '' },
      { src: '/collections/laconic/laconic_14.jpg', title: '' },
      { src: '/collections/laconic/laconic_15.jpg', title: '' },
      { src: '/collections/laconic/laconic_16.jpg', title: '' },
      { src: '/collections/laconic/laconic_17.jpg', title: '' },
      { src: '/collections/laconic/laconic_18.jpg', title: '' },
      { src: '/collections/laconic/laconic_19.jpg', title: '' },
      { src: '/collections/laconic/laconic_21.jpg', title: '' },
      { src: '/collections/laconic/laconic_22.jpg', title: '' },
      { src: '/collections/laconic/laconic_23.jpg', title: '' },
      { src: '/collections/laconic/laconic_24.jpg', title: '' },
      { src: '/collections/laconic/laconic_25.jpg', title: '' },
      { src: '/collections/laconic/laconic_26.jpg', title: '' },
      { src: '/collections/laconic/laconic_27.jpg', title: '' },
      { src: '/collections/laconic/laconic_28.jpg', title: '' },
      { src: '/collections/laconic/laconic_29.jpg', title: '' },
      { src: '/collections/laconic/laconic_30.jpg', title: '' },
    ],
  },
  {
    id: '6',
    title: 'Торты',
    description: 'Романтичные',
    src: collectionImages.romantic,
    isWide: false,
    isShow: false,
    direct: 'column',
    images: [
      { src: '/collections/romantic/romantic_2.jpg', title: '' },
      { src: '/collections/romantic/romantic_5.jpg', title: '' },
      { src: '/collections/romantic/romantic_6.jpg', title: '' },
      { src: '/collections/romantic/romantic_7.jpg', title: '' },
      { src: '/collections/romantic/romantic_8.jpg', title: '' },
      { src: '/collections/romantic/romantic_11.jpg', title: '' },
      { src: '/collections/romantic/romantic_12.jpg', title: '' },
      { src: '/collections/romantic/romantic_13.jpg', title: '' },
      { src: '/collections/romantic/romantic_14.jpg', title: '' },
    ],
  },
  {
    id: '7',
    title: 'Торты',
    description: 'Яркие и дерзкие',
    src: collectionImages.bright,
    isWide: false,
    isShow: false,
    direct: 'column',
    images: [
      { src: '/collections/bright/bright_1.jpg', title: '' },
      { src: '/collections/bright/bright_2.jpg', title: '' },
      { src: '/collections/bright/bright_3.jpg', title: '' },
      { src: '/collections/bright/bright_5.jpg', title: '' },
      { src: '/collections/bright/bright_6.jpg', title: '' },
      { src: '/collections/bright/bright_7.jpg', title: '' },
      { src: '/collections/bright/bright_8.jpg', title: '' },
      { src: '/collections/bright/bright_10.jpg', title: '' },
      { src: '/collections/bright/bright_11.jpg', title: '' },
      { src: '/collections/bright/bright_12.jpg', title: '' },
      { src: '/collections/bright/bright_13.jpg', title: '' },
      { src: '/collections/bright/bright_14.jpg', title: '' },
    ],
  },
  {
    id: '8',
    title: 'Торты',
    description: 'Классика',
    src: collectionImages.classic,
    isWide: false,
    isShow: false,
    direct: 'row',
    images: [
      // { src: '/collections/classic/classic_1.jpg', title: 'Кокосовое пирожное' },
      { src: '/collections/classic/classic_2.jpg', title: 'Боншанс красный' },
      { src: '/collections/classic/classic_3.jpg', title: 'Боншанс синий' },
      { src: '/collections/classic/classic_4.jpg', title: 'Рейк торт' },
      { src: '/collections/classic/classic_5.jpg', title: 'Дос-потатос' },
      {
        src: '/collections/classic/classic_8.jpg',
        title: 'Торт «Игрушка» для девочки',
      },
      {
        src: '/collections/classic/classic_9.jpg',
        title: 'Торт «Игрушка» для мальчика',
      },
      { src: '/collections/classic/classic_7.jpg', title: 'Сметанник' },
      {
        src: '/collections/classic/classic_12.jpg',
        title: 'Сметанник с ягодами',
      },
      { src: '/collections/classic/classic_10.jpg', title: 'Французский торт' },
      { src: '/collections/classic/classic_11.jpg', title: 'Шато' },
      // { src: '/collections/classic/classic_13.jpg', title: 'Птичка и молоко' },
      { src: '/collections/classic/classic_14.jpg', title: 'Кето-чизкейк' },
    ],
  },
]

export default COLLECTION_LIST
